import ScanQRCode from './ScanQRCode'
export default ScanQRCode